for (var vA391 = [{
    name: "Boosted",
    key: "speed",
    timer: 0,
    def: 1,
    max: 5,
    mlt: 0.1,
    mid: 41,
    execute: function (p9782, p9783) {
      var v7939 = 1 + p9783.effects[this.index] * this.mlt;
      p9783.attributes[this.key] = v7939;
    }
  }, {
    name: "Sleight of Hand",
    key: "reload",
    timer: 0,
    def: 1,
    max: 5,
    mlt: 0.1,
    mid: 42,
    execute: function (p9784, p9785) {
      var v7940 = 1 - p9785.effects[this.index] * this.mlt;
      p9785.attributes[this.key] = Math.abs(v7940);
    }
  }, {
    name: "Rapid Fire",
    key: "fRate",
    timer: 0,
    def: 1,
    max: 5,
    mlt: 0.05,
    mid: 43,
    execute: function (p9786, p9787) {
      var v7941 = 1 - p9787.effects[this.index] * this.mlt;
      p9787.attributes[this.key] = Math.abs(v7941);
    }
  }, {
    name: "Siphon",
    key: "siphon",
    timer: 0,
    def: 0,
    max: 5,
    hp: 10,
    mlt: 1,
    mid: 44,
    execute: function (p9788, p9789) {
      var v7942 = p9789.effects[this.index] * this.mlt;
      p9789.attributes[this.key] = v7942 * this.hp;
    }
  }, {
    name: "Rooted",
    key: "rooted",
    timer: 25,
    def: 1,
    max: 2,
    mlt: 0.25,
    mid: 45,
    execute: function (p9790, p9791) {
      var v7943 = 1 - p9791.effects[this.index] * this.mlt;
      p9791.attributes[this.key] = Math.abs(v7943);
    }
  }, {
    name: "Dizzy",
    key: "drunk",
    timer: 35,
    def: 0,
    max: 4,
    mlt: 0.25,
    mid: 46,
    execute: function (p9792, p9793) {
      var v7944 = p9793.effects[this.index] * this.mlt;
      p9793.attributes[this.key] = v7944;
    }
  }, {
    name: "Poisoned",
    key: "enraged",
    timer: 40,
    def: 0,
    hp: 10,
    max: 1,
    mlt: 1,
    mid: 47,
    execute: function (p9794, p9795) {
      var v7945 = p9795.effects[this.index] * this.mlt;
      p9795.attributes[this.key] = v7945 * this.hp;
    }
  }, {
    name: "Jump Boost",
    key: "jump",
    timer: 0,
    def: 1,
    max: 5,
    mlt: 0.1,
    mid: 51,
    execute: function (p9796, p9797) {
      var v7946 = 1 + p9797.effects[this.index] * this.mlt;
      p9797.attributes[this.key] = v7946;
    }
  }, {
    name: "Zapped",
    key: "zap",
    timer: 5,
    def: 0,
    hp: 2,
    max: 10,
    mlt: 0.5,
    mid: 52,
    execute: function (p9798, p9799) {
      var v7947 = p9799.effects[this.index] * this.mlt;
      p9799.attributes[this.key] = v7947 * this.hp;
    }
  }, {
    name: "Strength",
    key: "dmg",
    timer: 0,
    def: 1,
    max: 10,
    mlt: 0.1,
    mid: 53,
    execute: function (p9800, p9801) {
      var v7948 = 1 + p9801.effects[this.index] * this.mlt;
      p9801.attributes[this.key] = v7948;
    }
  }], vLN01295 = 0; vLN01295 < vA391.length; vLN01295++) {
  vA391[vLN01295].index = vLN01295;
}
module.exports = vA391;